import { ShieldCheck } from "lucide-react";

// Persistent approval-trust chrome (scenario 675, plan 188 task 802).
// Rendered on EVERY dock/drawer/full-page state — empty, working, reply,
// budget, error, confirm — never conditionally hidden. Realizes D1/D5: the
// model never sends, the pro approves every send.
export function TrustLine() {
  return (
    <p
      data-testid="copilot-trust-line"
      className="flex items-center justify-center gap-1.5 border-t border-border-soft px-3 py-2 text-[11px] text-fg-muted"
    >
      <ShieldCheck size={12} aria-hidden />
      Sill drafts — you approve every send.
    </p>
  );
}
